var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTWarning = function SvgTWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.40039,
    cy: 12,
    r: 1,
    fill: "#DF542F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87138 1.21553L0.871382 14.2155C0.656139 14.6153 0.94566 15.1 1.39966 15.1H15.3997C15.8537 15.1 16.1432 14.6153 15.9279 14.2155L8.92795 1.21553C8.70141 0.794814 8.09792 0.794814 7.87138 1.21553ZM8.39966 2.76499L14.3947 13.9H2.40366L8.39966 2.76499ZM8.99181 5.90267C8.94531 5.61758 8.6979 5.39999 8.39966 5.39999C8.06829 5.39999 7.79966 5.66862 7.79966 5.99999V9.49999L7.80752 9.59732C7.85402 9.8824 8.10143 10.1 8.39966 10.1C8.73104 10.1 8.99967 9.83136 8.99967 9.49999V5.99999L8.99181 5.90267Z",
    fill: "#DF542F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTWarning, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/TWarning.6c4c729e.svg";
export { ForwardRef as ReactComponent };